const TONES = {
  "Google Ads": "bg-blue-500/20 text-blue-200 border-blue-400/30",
  "Meta Ads": "bg-indigo-500/20 text-indigo-200 border-indigo-400/30",
  "Organic Google": "bg-emerald-500/20 text-emerald-200 border-emerald-400/30",
  "Social Media": "bg-pink-500/20 text-pink-200 border-pink-400/30",
  Direct: "bg-slate-500/20 text-slate-200 border-slate-400/30",
  "Agent Referral": "bg-amber-500/20 text-amber-200 border-amber-400/30",
  "Other Referral": "bg-orange-500/20 text-orange-200 border-orange-400/30",
};

export const SourceBadge = ({ source, testId }) => {
  const s = source || "Unknown";
  return (
    <span data-testid={testId} title="Original lead source"
      className={`inline-flex items-center text-[10px] font-semibold px-2 py-0.5 rounded-full border ${TONES[s] || "bg-white/10 text-emerald-100/70 border-white/15"}`}>
      {s}
    </span>
  );
};
